<template>
  <div
    class="fapi-form-simple-error-line f-p-2 f-mb-2 f-text-red-600 f-text-center"
  >
    {{ message }}
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "SimpleErrorLine",

  props: {
    message: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss"></style>
